import { AbstractPlayer } from './AbstractPlayer';
export class BrowserPlayer extends AbstractPlayer {
    constructor(desiredVideoQuality, logger, broadcast, mediaControl) {
        super(desiredVideoQuality, logger);
        this.desiredVideoQuality = desiredVideoQuality;
        this.logger = logger;
        this.broadcast = broadcast;
        this.mediaControl = mediaControl;
        this.currentlyPlaying = null;
        this.preloaded = null;
    }
    initialize() {
        this.broadcast.broadcast('player:initialize');
        this.logger.debug('[BrowserPlayer] Initialized successfully', { __broadcast: this.broadcast });
    }
    play(item, when) {
        if (this.preloaded && this.preloaded.item.id !== item.id) {
            this.logger.notice('[BrowserPlayer] Preloaded item no longer matches the requested item. Aborting play.', {
                preloadedId: this.preloaded.item.id,
                preloaded: this.preloaded,
                requestedId: item.id,
                requested: item,
                __broadcast: this.broadcast,
            });
            return;
        }
        if (!this.preloaded || this.preloaded.item.id !== item.id) {
            this.logger.warning('[BrowserPlayer] No preloaded item found for the requested play item ID: ' + item.id, {
                preloadedId: this.preloaded?.item?.id,
                requestedId: item.id,
                type: item.playable.type,
                name: item.playable.name,
                playableId: item.playable.id,
                __broadcast: this.broadcast,
            });
            return;
        }
        this.broadcast.broadcast('player:play', this.preloaded.item, this.preloaded.odd, when);
        this.currentlyPlaying = { odd: this.preloaded.odd, item: this.preloaded.item };
        this.preloaded = null;
        this.logger.debug('[BrowserPlayer] Will play id: ' + item.id, {
            when: when.toISOString(),
            type: item.playable.type,
            name: item.playable.name,
            playableId: item.playable.id,
            __broadcast: this.broadcast,
        });
    }
    stop(item, when, force = false) {
        if (!this.currentlyPlaying)
            return; // Safety check
        this.logger.debug('[BrowserPlayer] Will stop playback for ID: ' + item.id, {
            when: when.toISOString(),
            type: item.playable.type,
            __broadcast: this.broadcast,
        });
        if (this.currentlyPlaying.item.id !== item.id && !force) {
            /*this.logger.info('[BrowserPlayer] Currently playing item ID does not match the stop request ID. Ignoring stop.', {
              playingId: this.currentlyPlaying.item.id,
              stopRequestedId: item.id,
              __broadcast: this.broadcast,
            });*/
            return;
        }
        this.broadcast.broadcast('player:stop', this.currentlyPlaying.item, this.currentlyPlaying.odd, when, force);
    }
    preload(item) {
        if (this.preloaded && this.preloaded.item.id === item.id) {
            return;
        }
        if (!this.mediaControl.isDownloaded(item.playable)) {
            this.logger.warning('[BrowserPlayer] Tried to preload an item that is not downloaded locally. Ignoring.', {
                itemId: item.id,
                playableId: item.playable.id,
                __broadcast: this.broadcast,
            });
            return;
        }
        const mediaPath = this.mediaControl.getDownloadedPath(item.playable);
        this.logger.debug('[BrowserPlayer] Preloading: ' + item.id, {
            when: new Date().toISOString(),
            type: item.playable.type,
            name: item.playable.name,
            playableId: item.playable.id,
            quality: this.desiredVideoQuality,
            path: mediaPath,
            __broadcast: this.broadcast,
        });
        const odd = this.currentlyPlaying ? !this.currentlyPlaying.odd : true;
        this.broadcast.broadcast('player:preload', item, odd, mediaPath);
        this.preloaded = { odd, item };
    }
    idle(isSomethingPlanned, nextItemAt, isExiting) {
        this.clearAllTimers();
        this.broadcast.broadcast('player:idle', isSomethingPlanned, nextItemAt, isExiting ?? false);
        this.currentlyPlaying = null;
        this.preloaded = null;
        this.logger.debug('[BrowserPlayer] Idling. Something planned: ' + isSomethingPlanned + (nextItemAt ? ', next item at: ' + nextItemAt.toISOString() : ''), {
            __broadcast: this.broadcast,
        });
    }
    sync(item, seekTo, when) {
        if (item.id !== this.currentlyPlaying?.item.id) {
            this.logger.info('[BrowserPlayer] Tried to sync an item that is not currently playing. Ignoring.', {
                itemId: item.id,
                currentlyPlayingId: this.currentlyPlaying?.item.id,
                __broadcast: this.broadcast,
            });
            return;
        }
        this.logger.debug('[BrowserPlayer] Syncing playback for type: ' + item.playable.type + ' to ' + seekTo + ' seconds', {
            when: when.toISOString(),
            __broadcast: this.broadcast,
        });
        this.broadcast.broadcast('player:sync', this.currentlyPlaying.item, this.currentlyPlaying.odd, when, seekTo);
    }
    async destroy() {
        this.clearAllTimers();
        this.logger.debug('[BrowserPlayer] Destroying BrowserPlayer...', { __broadcast: this.broadcast });
        this.idle(false, null, true);
    }
}
//# sourceMappingURL=BrowserPlayer.js.map